import { SxProps, Theme } from "@mui/material/styles";
import { getColors } from '../../../utils'

const styles = (theme: Theme) => ({
    container: {
        position: "fixed",
        zIndex: 999,
        marginTop: '33px',
        right: 32,
        [theme.breakpoints.down("md")]: {
            bottom: 16,
            left: 0,
            right: 0,
            width: "90%",
            maxWidth: "358px",
            margin: "0 auto",
        },
        width: 380,
        padding: "16px",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 2,
        display: 'flex',
        borderRadius: "16px",
        border: getColors().border,
        background: theme.palette.background.paper,
        boxShadow:
            "0 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
        color: getColors().text,
    } as SxProps<Theme>,

    header: {
        display: "flex",
        alignItems: "flex-start",
        width: "100%",
    } as SxProps<Theme>,

    title: {
        flex: 1,
        pr: 2,
    } as SxProps<Theme>,

    imagesContainer: {
        flexShrink: 0,
        display: "flex",
        ml: "auto",
    } as SxProps<Theme>,

    status: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        display: "block",
        width: 240,
    } as SxProps<Theme>,
    link: {
        display: 'flex',
        padding: 0,
        gap: '8px',
        color: theme.palette.primary.main,
        cursor: 'pointer'
    }
});

export default styles;